import { Box, Typography } from '@mui/material';
import { FC, Fragment, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useSearchParams } from 'react-router-dom';

import { ReactComponent as FailureIconVs } from 'src/assets/svg/failure-red-circle.svg';
import { ReactComponent as FailureIconHos } from 'src/assets/svg/failure-red-circle-hos.svg';
import { Button } from 'src/components/button';
import { useGetBasketById } from 'src/lib/hooks/use-get-basket-by-id';
import { getStlRoomsUrl } from 'src/utils/get-stl-rooms-url';
import { appConfig } from 'src/app';
import { removeStorage } from 'src/utils/local-storage-versioning';
import { getTheme } from 'src/utils/getTheme';

import { styles } from './styles';

const { isHosTheme } = getTheme();

const FailureIcon: FC = () => (isHosTheme ? <FailureIconHos /> : <FailureIconVs />);

const TextWrapper: FC<{ children: ReactNode }> = (props) => {
    const Wrapper = isHosTheme ? Box : Fragment;

    return <Wrapper>{props.children}</Wrapper>;
};

export const RoomNotAvailable: FC = () => {
    const { t } = useTranslation();
    const { vs, hos } = appConfig.brochureSiteUrl;
    const { state } = useLocation();
    const [searchParams] = useSearchParams();
    const developmentSlug = searchParams.get('developmentSlug') || null;
    const { data: basket, isLoading } = useGetBasketById();
    removeStorage();

    const failedRoomsUrl: string | null | undefined = state?.roomsUrl;
    let homeUrl = isHosTheme ? hos : vs;

    if (failedRoomsUrl) {
        homeUrl = failedRoomsUrl;
    } else if (failedRoomsUrl === undefined && developmentSlug) {
        homeUrl = getStlRoomsUrl(developmentSlug, basket) ?? homeUrl;
    }

    return (
        <Box css={styles.container}>
            <Box css={styles.imageContainer} />

            <Box css={styles.wrapper}>
                <FailureIcon />

                <TextWrapper>
                    <Typography variant="h1" css={styles.title}>
                        {t('room_not_available_title')}
                    </Typography>

                    <Typography variant="body3">{t('room_not_available_content')}</Typography>
                </TextWrapper>

                <Button
                    {...(isHosTheme && { design: 'light', bordered: true })}
                    css={styles.cta}
                    href={homeUrl}
                    loading={failedRoomsUrl === undefined && isLoading}
                >
                    {t('room_not_available_btn')}
                </Button>
            </Box>
        </Box>
    );
};
